import React, { useState, useRef, useEffect } from 'react'
import './ForgetPassword.css';
import { LoginService } from '../services/LoginService';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { fetchpassData } from './../reduxactions/organizationactions/OrgDonationsActions';
import { Link } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers';

const imageName = require("./../assets/img/gfn.png");

export const Forgetpassword = () => {
  const uid = window.sessionStorage.getItem('uid');
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const pass = useSelector((state: RootState) => state.orgdon.forgotpass);


  const msgs = useRef(null);
  useEffect(() => {
    if (pass && pass.length > 0) {
      toast.current.show({ severity: 'info', summary: 'info', detail: pass, life: 3000 })

    }

  }, [pass]);
  const handleSubmit = async () => {
    try {

      if (email.trim() === '') {

        return;
      }

      await dispatch(fetchpassData(email) as any);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);


    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const toast = useRef(pass);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateEmail = (value: string) => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setErrors((prev) => ({ ...prev, email: 'Invalid email format' }));
    } else {
      setErrors((prev) => ({ ...prev, email: '' }));
    }
    setEmail(value);
  };
  const isFormValid = email && Object.values(errors).every((error) => !error);
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/forgot.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };


  return (
    <div className="main-body">

      {/* Help Bar */}
      <div className="login-help-bar">
        <a
          title="help"
          onClick={(e) => openWindow(e, IUrl)}
          className="app-help-link"
        >
          Help for this Page
          <i className="pi pi-question-circle"></i>
        </a>
      </div>

      {/* Main Page */}
      <div className="login-page">

        <div className="login-shell">

          {/* LEFT SIDE */}
          <aside className="login-hero">

            <div className="login-brand">

              <img
                src={imageName}
                alt="GearForNeed logo"
              />

              <h1>
                Recover your account securely.
              </h1>

              <p>
                Enter your registered email address to receive password
                reset instructions and regain access to your GearForNeed
                account quickly and securely.
              </p>

            </div>

            {/* Features */}
            <div className="login-feature-list">

              <div className="login-feature">
                <i className="pi pi-lock"></i>

                <span>
                  Safe and secure password recovery workflow.
                </span>
              </div>

              <div className="login-feature">
                <i className="pi pi-envelope"></i>

                <span>
                  Password reset instructions sent directly to your email.
                </span>
              </div>

              <div className="login-feature">
                <i className="pi pi-mobile"></i>

                <span>
                  Fully responsive experience across all devices.
                </span>
              </div>

            </div>

          </aside>

          {/* RIGHT SIDE */}
          <section className="login-card">

            <div className="login-card-inner">

              {/* Header */}
              <div className="login-card-header">

                <h2>Forgot Password</h2>

                <p>
                  Use your registered email address to continue.
                </p>

              </div>

              {/* Form */}
              <div className="login-form">

                {/* Email */}
                <div className="login-field">

                  <label htmlFor="email">
                    Email Address
                  </label>

                  <span className="p-input-icon-left w-full">

                    <i className="pi pi-envelope"></i>

                    <InputText
                      id="email"
                      type="email"
                      placeholder="Enter your email address"
                      className={`w-full ${errors.email ? 'p-invalid' : ''
                        }`}
                      value={email}
                      onChange={(e) =>
                        validateEmail(e.target.value)
                      }
                      data-testid="email-input"
                    />

                  </span>

                  {errors.email && (
                    <small className="p-error">
                      {errors.email}
                    </small>
                  )}

                </div>

                {/* Button */}
                <Button
                  onClick={handleSubmit}
                  disabled={!isFormValid}
                  label="Request New Password"
                  icon="pi pi-send"
                  severity="info"
                  className="w-full"
                  data-testid="request-password-btn"
                />

              </div>

              {/* Bottom Links */}
              <div className="login-register">

                <span>
                  Remember your password?
                </span>

                <Link
                  to="/"
                  className="login-link"
                >
                  Back to Login
                </Link>

              </div>

            </div>

          </section>

        </div>

      </div>

      {/* Toast */}
      <Toast ref={toast} />

    </div>
  );
}
